<template>
  <div class="tab reverseInterval">
    <div class="header">
      <div
        class="list"
        v-for="(item, index) in navigationList"
        :key="index"
        @click="navigationHit(index, item)"
      >
        {{ item.title }}
      </div>
    </div>

    <div class="hint">
      © 2025 Mingteng International Corp Inc. All Rights Reserved.
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navigationList: this.$store.state.navigationList,
    };
  },
  methods: {
    navigationHit(index, item) {
      this.navigationActive = index;

      this.$router.push({
        path: item.path,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.tab {
  padding-top: 80px;
  padding-bottom: 80px;
  box-sizing: border-box;
  background: #30353e;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-around;
    .list {
      text-align: center;
      font-size: 20px;
      font-weight: 500;
      color: #fff;
      cursor: pointer;
    }
  }

  .hint {
    margin-top: 100px;
    font-size: 22px;
    font-weight: 500;
    color: #fff;
  }
}
</style>